import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import Layout from './components/Layout/Layout';
import './App.css';
import routes from './config/routes';
import theme from './theme';

function App() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const hasAccount = useSelector((state) => state.auth.hasAccount);

  const withLayout = (Component, minimalLayout) => () => (
    <Layout minimal={minimalLayout}><Component /></Layout>
  );

  const defineRoute = (route) => {
    const Component = withLayout(route.component, route.minimalLayout);
    return (
      <Route
        path={route.path}
        component={Component}
        key={route.path}
      />
    );
  };

  const publicRoutes = (routes.public.map((route) => defineRoute(route)));

  const loginRoute = defineRoute(routes.authentication.login);
  const signupRoute = defineRoute(routes.authentication.signup);

  const protectedRoutes = (routes.protected.map((route) => defineRoute(route)));

  // 🔑 L'orientation des visiteurs se fait ICI, et nulle part ailleurs.
  //
  // Quelqu'un qui atterrit sur une adresse inconnue sans être connecté va vers
  // l'inscription si ce navigateur n'a jamais vu de compte, vers la connexion
  // sinon. `hasAccount` vient de `localStorage` : il dit « ce navigateur a
  // déjà servi », pas « cette personne a un compte ».
  //
  // ⚠️ C'est pourquoi il ne doit JAMAIS garder /login : le drapeau est vide sur
  // un poste neuf, et une bibliothécaire qui change d'ordinateur se retrouvait
  // devant un formulaire d'inscription pour un compte qu'elle a déjà.
  const parDefaut = hasAccount
    ? routes.authentication.login.path
    : routes.authentication.signup.path;
  const defaultRedirect = isLoggedIn ? routes.default.path : parDefaut;

  return (
    <StyledEngineProvider injectFirst>
      {/* ⛔ Pas de parenthèses ni de « ... » en clair ici : dans du JSX, ce
          sont des nœuds de TEXTE, et ils s'affichaient vraiment — un « ) »
          solitaire traînait sous le contenu de chaque page. */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Switch>
          {publicRoutes}
          {isLoggedIn ? protectedRoutes : []}
          {loginRoute}
          {signupRoute}
          <Redirect to={defaultRedirect} />
        </Switch>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
